import { render, staticRenderFns } from "./CreateContent.vue?vue&type=template&id=3ab91eb9&scoped=true"
import script from "./CreateContent.vue?vue&type=script&lang=js"
export * from "./CreateContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab91eb9",
  null
  
)

export default component.exports